import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import ButtonGroupProps from './ButtonGroupProps'


export default {
    template: '<ul><slot></slot></ul>',
    props: ButtonGroupProps,
    mixins: [
        KendoBaseComponent
    ],
    mounted() {
        kendo.jQuery(this.$el).kendoButtonGroup(this.widgetOptions)

        this.$emit('kendowidgetready', this.kendoWidget())
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoButtonGroup()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-buttons-vue-wrapper/src/KendoButtonGroup/KendoButtonGroupMixin.js